import { useLocation, globalHistory, useNavigate } from "@reach/router";
import React, { useEffect } from "react";

const defaultMessage = "You have not saved the form. Any changes will be lost if you leave this page.";

const usePromptOnNavigate = (shouldPrompt:boolean, message:string = defaultMessage):void => {
  const curLocation = useLocation();
  const navigate = useNavigate();

  useEffect(
    () =>
      globalHistory.listen(({ action, location }) => {
        if ((action === "PUSH" && !location.pathname.includes(curLocation.pathname)) || action === "POP") {
          // eslint-disable-next-line no-alert
          if (shouldPrompt && !window.confirm(message)) {
            navigate(`${curLocation.pathname}`);
          }
        }
      })
    , [shouldPrompt],
  );
};

const PromptOnNavigate:React.FC<{shouldPrompt:boolean, message?:string}> =
({ shouldPrompt, message }) => {
  usePromptOnNavigate(shouldPrompt, message);

  return null;
};

export { usePromptOnNavigate, PromptOnNavigate };
